/**
 * Generate Domain Pack Page
 * Smart wizard for AI-powered domain pack creation
 *
 * Updated: November 2025 - Phase 3+ Smart Wizard Integration
 */

import React from 'react';
import { SmartDomainWizard } from '../components/domain-packs/SmartDomainWizard';

const GenerateDomainPack: React.FC = () => {
  return <SmartDomainWizard />;
};

export default GenerateDomainPack;
